import { nameValuePair, nameValuePairLang } from '../../models/keyValuePair';

export const languageConst: Array<nameValuePair> = [
  {
    name: 'English',
    code: 'en',
  },
  {
    name: 'Arabic',
    code: 'ar',
  },
  {
    name: 'Malayalam',
    code: 'ml',
  },
];

export const availableLanguages: Array<string> = ['en', 'ar', 'ml'];

export const languageConstAdd: Array<nameValuePairLang> = [
  {
    name: 'English',
    code: 'en',
  },
  {
    name: 'Arabic',
    code: 'ar',
  },
  {
    name: 'Malayalam',
    code: 'ml',
  },
];
